import { Badge } from "@mantine/core";
import { FIT_TIER_COLORS, FIT_TIER_LABELS } from "../../constants/matching";

export function FitTierBadge({
  tier,
  score,
}: {
  tier?: string | null;
  score?: number | null;
}) {
  if (!tier) return null;
  const label = FIT_TIER_LABELS[tier] ?? tier;
  const color = FIT_TIER_COLORS[tier] ?? "gray";
  const scoreLabel = score != null ? ` ${Math.round(score)}` : "";
  return (
    <Badge variant="outline" color={color} size="sm">
      {label}
      {scoreLabel}
    </Badge>
  );
}
